export const SET_APARTMENT_DATA_SUCCESS = 'SET_APARTMENT_DATA_SUCCESS';
export const SET_SELECT_ROOMS_SUCCESS = 'SET_SELECT_ROOMS_SUCCESS';
export const SET_SELECTED_NUMBER_PRIVATE_ACCIDENT_INSURANCE = 'SET_SELECTED_NUMBER_PRIVATE_ACCIDENT_INSURANCE';
export const SET_COMPREHENSIVE_INSURANCE_DATA_SUCCESS = 'SET_COMPREHENSIVE_INSURANCE_DATA_SUCCESS';
export const SET_INCREASED_TRAVEL_PROTECTION_INSURANCE_DATA_SUCCESS = 'SET_INCREASED_TRAVEL_PROTECTION_INSURANCE_DATA_SUCCESS';
export const SET_PERSONAL_ACCIDENT_INSURANCE_DATA_SUCCESS = 'SET_PERSONAL_ACCIDENT_INSURANCE_DATA_SUCCESS';
export const SET_TENTANT_INSURANCE_DATA_SUCCESS = 'SET_TENTANT_INSURANCE_DATA_SUCCESS';
export const SET_SMALL_BOATS_INSURANCE_DATA_SUCCESS = 'SET_SMALL_BOATS_INSURANCE_DATA_SUCCESS';
export const SET_SELECT_CONTACT_AREA_SUCCESS = 'SET_SELECT_CONTACT_AREA_SUCCESS';

const apartmentInsurances = [
  {name:'Allriskförsäkring'},
  {name:'Privat olycksfallsförsäkring'},
  {name:'Utökat reseskydd'},
  {name:'Bostadsrättsförsäkring'},
  {name:'Småbåtsförsäkring'}
];

export const setPrivateInsuranceData = (payload) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_PRIVATE_INSURANCE_DATA',
      payload: payload,
    });
  }
};

export const setFirstPrivateInsurancePersonSsn = (payload) => {
  return (dispatch) => {
      dispatch({
        type: 'UPDATE_FIRST_SSN_PRIVATE_INSURANCE_PERSON_SUCCESS',
        payload: payload
    });
  }
};

export const setFirstPrivateInsurancePersonName = (payload) => {
  return (dispatch) => {
      dispatch({
        type: 'UPDATE_FIRST_NAME_PRIVATE_INSURANCE_PERSON_SUCCESS',
        payload: payload
    });
  }
};

export const setSecondPrivateInsurancePersonSsn = (payload) => {
  return (dispatch) => {
      dispatch({
        type: 'UPDATE_SECOND_SSN_PRIVATE_INSURANCE_PERSON_SUCCESS',
        payload: payload
    });
  }
};

export const setSecondPrivateInsurancePersonName = (payload) => {
  return (dispatch) => {
      dispatch({
        type: 'UPDATE_SECOND_NAME_PRIVATE_INSURANCE_PERSON_SUCCESS',
        payload: payload
    });
  }
};

export const setThirdPrivateInsurancePersonSsn = (payload) => {
  return (dispatch) => {
      dispatch({
        type: 'UPDATE_THIRD_SSN_PRIVATE_INSURANCE_PERSON_SUCCESS',
        payload: payload
    });
  }
};

export const setThirdPrivateInsurancePersonName = (payload) => {
  return (dispatch) => {
      dispatch({
        type: 'UPDATE_THIRD_NAME_PRIVATE_INSURANCE_PERSON_SUCCESS',
        payload: payload
    });
  }
};

export const setFourthPrivateInsurancePersonSsn = (payload) => {
  return (dispatch) => {
      dispatch({
        type: 'UPDATE_FOURTH_SSN_PRIVATE_INSURANCE_PERSON_SUCCESS',
        payload: payload
    });
  }
};

export const setFourthPrivateInsurancePersonName = (payload) => {
  return (dispatch) => {
      dispatch({
        type: 'UPDATE_FOURTH_NAME_PRIVATE_INSURANCE_PERSON_SUCCESS',
        payload: payload
    });
  }
};

export const setFifthPrivateInsurancePersonSsn = (payload) => {
  return (dispatch) => {
      dispatch({
        type: 'UPDATE_FIFTH_SSN_PRIVATE_INSURANCE_PERSON_SUCCESS',
        payload: payload
    });
  }
};

export const setFifthPrivateInsurancePersonName = (payload) => {
  return (dispatch) => {
      dispatch({
        type: 'UPDATE_FIFTH_NAME_PRIVATE_INSURANCE_PERSON_SUCCESS',
        payload: payload
    });
  }
};

export const setApartmentDataSuccess = (payload) => {
    return {
        type: SET_APARTMENT_DATA_SUCCESS,
        // field: field,
        payload: payload,
    }
};

export const setApartmentData = (payload) => {

    return (dispatch) => {
        dispatch(setApartmentDataSuccess(payload));
    }
};

export const selectNrOfRoomsSuccess = (data) => {
  return {
      type: SET_SELECT_ROOMS_SUCCESS,
      data: data
  }
};

export const selectNrOfRooms = (rooms) => {
  return (dispatch) => {
      dispatch(selectNrOfRoomsSuccess(rooms));
  }
};

export const setComprehensiveInsuranceDataSuccess = (data) => {
  return {
      type: SET_COMPREHENSIVE_INSURANCE_DATA_SUCCESS,
      data: data
  }
};

export const setComprehensiveInsuranceData = (data) => {
  return (dispatch) => {
      dispatch(setComprehensiveInsuranceDataSuccess(data));
  }
};

export const setIncreasedTravelProtectionInsuranceDataSuccess = (data) => {
  return {
      type: SET_INCREASED_TRAVEL_PROTECTION_INSURANCE_DATA_SUCCESS,
      data: data
  }
};

export const setIncreasedTravelProtectionInsuranceData = (data) => {
  return (dispatch) => {
      dispatch(setIncreasedTravelProtectionInsuranceDataSuccess(data));
  }
};

export const setPersonalAccidentInsuranceDataSuccess = (data) => {
  return {
      type: SET_PERSONAL_ACCIDENT_INSURANCE_DATA_SUCCESS,
      data: data
  }
};

export const setPersonalAccidentInsuranceData = (data) => {
  return (dispatch) => {
      dispatch(setPersonalAccidentInsuranceDataSuccess(data));
  }
};

export const setTentantInsuranceDataSuccess = (data) => {
  return {
      type: SET_TENTANT_INSURANCE_DATA_SUCCESS,
      data: data
  }
};

export const setTentantInsuranceData = (data) => {
  return (dispatch) => {
      dispatch(setTentantInsuranceDataSuccess(data));
  }
};

export const setSmallBoatsInsuranceDataSuccess = (data) => {
  return {
      type: SET_SMALL_BOATS_INSURANCE_DATA_SUCCESS,
      data: data
  }
};

export const setSmallBoatsInsuranceData = (data) => {
  return (dispatch) => {
      dispatch(setSmallBoatsInsuranceDataSuccess(data));
  }
};

export const addSecurityDoor = (data) => {
  return (dispatch) => {
    dispatch({
      type: 'ADD_SECURITY_DOOR_SUCCESS',
      data: data
    });
  }
}

export const setContactMeData = (data) => {
  return (dispatch) => {
    dispatch({
      type: 'ADD_CONTACT_ME_DATA_SUCCESS',
      data: data
    });
  }
}

export const setAdditionalJewelryInsurance = (data) => {
  return (dispatch) => {
    dispatch(
      {
        type: 'SET_ADDITIONAL_JEWELRY_INSURANCE',
        data: data
      }
    )
  }
}

export const setNumberOfPrivateAccidentInsuranceData = (nr) => {
  return (dispatch) => {
      dispatch({
        type: SET_SELECTED_NUMBER_PRIVATE_ACCIDENT_INSURANCE,
        data: nr
    });
  }
};

export const selectContactArea = (area) => {
  return (dispatch) => {
    dispatch({
      type: SET_SELECT_CONTACT_AREA_SUCCESS,
      data: area
    });
  }
}

export const setInsuranceStart = (date) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_INSURANCE_START',
      data: date
    })
  }
}

export const selectPayment = (payment) => {
  return (dispatch) => {
    dispatch({
      type: 'SET_SELECTED_PAYMENT_SUCCESS',
      data: payment
    })
  }
}

export const getApartmentInsuranceName = (id) => {
  return apartmentInsurances[id].name;
}

export const getApartmentInsuranceId = (id) => {
  return apartmentInsurances[id].id;
}